import { Text } from '@components/primitives';
import { AntDesign } from '@expo/vector-icons';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { View } from 'react-native';
import styles from './styles';

interface ToastErrorProps {
  data?: string;
  customStyle?: any;
}

const ToastError: React.FC<ToastErrorProps> = ({ data = '', customStyle = {} }) => (
  <View style={[styles.toastContainer, customStyle]}>
    <AntDesign name="warning" size={scale(24)} color={colors.neutral.cotton} />
    <Text testID="txtSuccess" variant="sm-bold" color={colors.neutral.cotton} style={styles.textStyle}>
      {data}
    </Text>
  </View>
);

export default ToastError;
